import React from 'react';
import Helmet from 'react-helmet';
import propTypes from 'prop-types';
import BackgroundStripped from '../../components/BackgroundStripped';
import PageHeading from '../../components/PageHeading';
import SqzButton from '../../components/SqzButton';

import Footer from '../../containers/Footer';
import Header from '../../containers/Header';

export default function Philanthropy(props) {
  return (
    <div className="appWrap">
      <div className="MainContentWrap">
        <Helmet titleTemplate="%s - Squeeze" defaultTitle="Squeeze">
          <title>
            A Way Better Massage Experience | Philanthropy | Squeeze Massage
          </title>
          <meta
            name="description"
            content="Get a feel-good massage from Squeeze. Use our app to save your massage preferences to your profile so your therapist knows what you want, each time. Book today! | A Feel Good Company"
          />
        </Helmet>
        <Header
          showCloseButton={false}
          showBackButton={false}
          showHamburgerMenu
        />

        <Header showHamburgerMenu />
        <PageHeading mobileTitle="It's Puppy Love!">
          It&rsquo;s puppy love!
        </PageHeading>
        <BackgroundStripped mobileTitle="We don't just massage your back, we give back!">
          We don&rsquo;t just massage your back, we give back!
        </BackgroundStripped>
        <div className="container">
          <div className="philanthropy">
            <div className="philanthropyText1">
              We&rsquo;ve partnered with{' '}
              <span className="PhilSpan">
                <a
                  aria-label="philanthrophy-cci-link"
                  href="http://www.cci.org/"
                  target="_blank"
                  className="philSpan"
                >
                  Canine Companions,
                </a>
              </span>{' '}
              a nonprofit organization dedicated to enhancing the lives of
              people with disabilities by providing expertly trained service
              dogs at no charge to the recipient.
            </div>
            <div className="philanthropyText2">
              For every membership sold, Squeeze is helping to provide a day of
              canine support to a person with a disability. Now, that&rsquo;s
              something to bark about!
            </div>
            <div className="philanthropyButton">
              <SqzButton
                addClass="buttonPhil"
                onClick={() => {
                  props.history.push('/membership');
                }}
              >
                GO TO MEMBERSHIPS
              </SqzButton>
            </div>
            <div className="philanthropyDog">
              <span className="icon-membership icon--dog--smiling" />
            </div>
            <h3 className="philanthropyThankYou">Thank you!</h3>
          </div>
        </div>
      </div>
      <div className="FootContentWrap">
        <Footer showItems />
      </div>
    </div>
  );
}

Philanthropy.propTypes = {
  history: propTypes.object,
};
